import { SxProps, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';

export interface Props {
  children: React.ReactNode;
  errorMessage: string;
  errorMessageSx?: SxProps<Theme>;
}

interface State {
  hasError: boolean;
}

export class ErrorsHandler extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Typography variant="body2" sx={this.props.errorMessageSx}>
          {this.props.errorMessage}
        </Typography>
      );
    }

    return this.props.children;
  }
}
